import "../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { defineCustomElement as n } from "../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
function l(t) {
  return (e) => {
    if (!e.startsWith("op-web-")) {
      console.error(`自定义元素名称 "${e}" 格式错误：必须以 "op-web-" 开头`);
      return;
    }
    if (customElements.get(e))
      console.log(`自定义元素 ${e} 已被注册`);
    else {
      const o = n(t);
      customElements.define(e, o);
    }
  };
}
export {
  l as defineAndRegisterElement
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/utils/register-element.js
// module id = 42
// module chunks = 41